import styled from "@emotion/styled";

interface Props {
	size?: string;
	color?: string;
}

export const RightArrows = (props: Props) => {

    const border = "4px solid "+(props.color ?? '#004885')
	return (
		<Container
			style={{
				width: props.size ?? "18px",
				height: props.size ?? "18px",
				borderTop: border,
				borderRight: border,
			}} />
	);
};
const Container = styled.div`
	transform: rotate(45deg);
	margin-top: 2px;
`;
